<mat-card class="margin-bottom-med">
  <mat-card-header>
    <mat-card-title>Payment Methods</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    @if (duplicateCardPlayers.length > 0) {
      <div class="duplicate-card-warning" data-testid="duplicate-card-warning">
        <div class="warning-header">
          <span class="warning-icon">&#9888;</span>
          <strong>Warning: Duplicate Card Detected</strong>
        </div>
        <p>This player's card is also being used by the following player(s):</p>
        <ul class="duplicate-players-list" data-testid="duplicate-players-list">
          @for (player of duplicateCardPlayers; track player.PlayerId) {
            <li>
              <a [routerLink]="getPlayerManageUrl(player.PlayerId)" data-testid="duplicate-player-link">
                {{ player.PlayerEmail }}
              </a>
              <span class="card-info">(Card ending in {{ player.CardLastFourDigits }})</span>
            </li>
          }
        </ul>
      </div>
    }

    @if (duplicateFingerprintError) {
      <div class="duplicate-fingerprint-error" data-testid="duplicate-fingerprint-error">
        <span class="error-icon">&#9888;</span>
        <span>Unable to check for duplicate card fingerprints. Please try again later.</span>
      </div>
    }

    <ag-grid-angular
      class="ag-theme-quartz margin-top-med margin-bottom-med player-payment-methods-table"
      data-testid="payment-methods-table"
      [tooltipShowDelay]=0
      domLayout='autoHeight'
      [rowHeight]="50"
      [pagination]="true"
      rowClass="table-row"
      [loading]="uiState === uiStateForTemplate.ShowLoading"
      (firstDataRendered)="onFirstDataRendered($event)"
      (gridSizeChanged)="gridSizeChanged($event)"
      overlayNoRowsTemplate="<span>This player has no payment methods for this game</span>"
      [rowData]="paymentMethods"
      [columnDefs]="paymentMethodsTableColDefs">
    </ag-grid-angular>

  </mat-card-content>
</mat-card>
